import { useQuery } from "@tanstack/react-query";
import { AthenaCredentials } from "@graylog/enterprise-api";
import i18n from "i18n";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
export const saveDataLakeConnector = async (connector) => {
  try {
    const { id } = await fetch(
      "POST",
      qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials/save`),
      connector
    );
    UserNotification.success(i18n.t("notifications.connector_saved", { ns: "enterprise_data_lake" }));
    return id;
  } catch (errorThrown) {
    UserNotification.error(
      i18n.t("notifications.connector_save_failed", { ns: "enterprise_data_lake", error: errorThrown }),
      i18n.t("notifications.connector_save_failed_title", { ns: "enterprise_data_lake" })
    );
  }
  return null;
};
export const deleteDataLakeConnector = async (id) => {
  try {
    await AthenaCredentials.deleteCredentials(id);
    UserNotification.success(i18n.t("notifications.connector_deleted", { ns: "enterprise_data_lake" }));
  } catch (errorThrown) {
    UserNotification.error(
      i18n.t("notifications.connector_delete_failed", { ns: "enterprise_data_lake", error: errorThrown }),
      i18n.t("notifications.connector_delete_failed_title", { ns: "enterprise_data_lake" })
    );
  }
};
export const fetchDataLakeConnectors = async () => fetch(
  "GET",
  qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials`)
);
export const DataLakeConnectorsQueryKey = "data-lake-connectors";
const useDataLakeConnectors = ({ refetchInterval = 5e3, enabled = true } = {}) => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: [DataLakeConnectorsQueryKey],
    queryFn: () => defaultOnError(
      fetchDataLakeConnectors(),
      i18n.t("notifications.fetch_connectors_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_connectors_failed_title", { ns: "enterprise_data_lake" })
    ),
    notifyOnChangeProps: ["data", "error"],
    refetchInterval,
    enabled
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeConnectors;
